export default {"src":"/_next/static/media/codex-native.32bf8ca6.svg","height":32,"width":32};